import { StyleSheet } from 'react-native';

import {
  TagLabelPalette as Palette,
  TagLabelSize as Size,
} from '../TagLabel.types';
import { COLORS, OPACITY } from '@garnish/constants';

/**
 * The styles are organized by component type: Box, Text
 *
 * Each component's stylesheet has styles for the disabled-state-- and then
 * palette-specific groups, with definitions for both standard + hovered/pressed
 *
 * These styles are highly structured because there's mapping complexity which
 * relies on a standardized signature.
 */

// -----------------------------------------------------------------------------
// ---- BOX STYLES -------------------------------------------------------------
// -----------------------------------------------------------------------------

export const boxStyles = StyleSheet.create({
  // -----------------------------------------
  // ---- PRIMARY ----------------------------
  [`${Palette.primary}`]: { backgroundColor: COLORS.LIME },

  // -----------------------------------------
  // ---- SECONDARY --------------------------
  [`${Palette.secondary}`]: {
    backgroundColor: OPACITY.TRANSPARENT,
    borderColor: COLORS.NEUTRAL_2,
    borderWidth: 1,
  },

  [`${Palette.tertiary}`]: {
    backgroundColor: COLORS.LIGHT,
  },

  // -----------------------------------------
  // ---- SIZES ------------------------------
  [Size.small]: { height: 24 },
  [Size.medium]: { height: 24 },
});

export const textStyles = StyleSheet.create({
  // -----------------------------------------
  // ---- PRIMARY ----------------------------
  [`${Palette.primary}`]: { color: COLORS.GREEN_1 },

  // -----------------------------------------
  // ---- SECONDARY --------------------------
  [`${Palette.secondary}`]: { color: COLORS.GREEN_1 },
  // -----------------------------------------
  // ---- SIZES ------------------------------
  [Size.small]: {
    fontSize: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  [Size.medium]: { fontSize: 12 },
  [Size.large]: {
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
});
